/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_Status_AppliedInputs */

const en_jobs_status_applied = /** @type {(inputs: Jobs_Status_AppliedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Applied`)
};

const de_jobs_status_applied = /** @type {(inputs: Jobs_Status_AppliedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beworben`)
};

const fr_jobs_status_applied = /** @type {(inputs: Jobs_Status_AppliedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Postulé`)
};

const es_jobs_status_applied = /** @type {(inputs: Jobs_Status_AppliedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Postulado`)
};

const it_jobs_status_applied = /** @type {(inputs: Jobs_Status_AppliedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Candidata`)
};

const nl_jobs_status_applied = /** @type {(inputs: Jobs_Status_AppliedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesolliciteerd`)
};

const pl_jobs_status_applied = /** @type {(inputs: Jobs_Status_AppliedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wysłano`)
};

const fi_jobs_status_applied = /** @type {(inputs: Jobs_Status_AppliedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haettu`)
};

const da_jobs_status_applied = /** @type {(inputs: Jobs_Status_AppliedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansøgt`)
};

const sv_jobs_status_applied = /** @type {(inputs: Jobs_Status_AppliedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansökt`)
};

/**
* | output |
* | --- |
* | "Applied" |
*
* @param {Jobs_Status_AppliedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_status_applied = /** @type {((inputs?: Jobs_Status_AppliedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Status_AppliedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_status_applied(inputs)
	if (locale === "fr") return fr_jobs_status_applied(inputs)
	if (locale === "es") return es_jobs_status_applied(inputs)
	if (locale === "it") return it_jobs_status_applied(inputs)
	if (locale === "nl") return nl_jobs_status_applied(inputs)
	if (locale === "pl") return pl_jobs_status_applied(inputs)
	if (locale === "fi") return fi_jobs_status_applied(inputs)
	if (locale === "da") return da_jobs_status_applied(inputs)
	if (locale === "sv") return sv_jobs_status_applied(inputs)
	return en_jobs_status_applied(inputs)
});